module.exports = __webpack_public_path__ + "img/file-icon.6221e371.svg";